import store from '@/store'

export default [
  {
    path: '/grades',
    name: 'grade',
    meta: { requiresAuth: true },
    component: () => import('@/pages/grade-v2/index')
  },
  {
    path: '/grades/create',
    name: 'grade-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/grade-v2/create')
  },
  {
    path: '/grades/:id',
    name: 'grade-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/grade-v2/edit'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('grade/find', to.params.id)
      next()
    }
  }
]
